import { useState } from 'react';
import { StackLayout } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { useSelector, useDispatch } from 'react-redux';
import { createContent, deleteContent, updateContent } from '../../actions';
import Content from '../../components/Content';
import ContentForm from '../../components/ContentForm';
import Dialog from '../../components/Dialog/Dialog';
import { formCloser } from '../../utils/formCloser';
import { setToContentDrawer, toggleDrawer } from '../../store/actions/drawerActions';

function DashboardPosts() {

  const dispatch = useDispatch();

  const { groups } = useSelector(state => state.groupsReducer);
  const { content } = useSelector(state => state.contentReducer);
  const { token, user } = useSelector(state => state.authReducer);
  const { contentFilter } = useSelector(state => state.filterReducer);

  const filteredContent = content.filter(listing => {
    let stringMatch = contentFilter.searchValue ? false : true;
    let groupMatch = contentFilter.selectedGroups && contentFilter.selectedGroups.length ? false : true;
    let typeMatch = contentFilter.selectedTypes && contentFilter.selectedTypes.length ? false : true;
    let calendarMatch = contentFilter.calendarDates.length || contentFilter.calendarDates.start ? false : true;

    //Filter by search value 
    if (contentFilter.searchValue) {
      ['title', 'location', 'address', 'website', 'details'].forEach(field => {
        if (listing[field] && listing[field].toLowerCase().includes(contentFilter.searchValue.toLowerCase())) {
          stringMatch = true;
        }
      })
    }
    //Filter by group
    if (contentFilter.selectedGroups && contentFilter.selectedGroups.length) {
      for (let filterGroup of contentFilter.selectedGroups) {
        for (let cg of listing.Groups) {
          if (filterGroup.id === cg.id) {
            groupMatch = true;
          }
        }
      }
    }
    //Filter by type
    if (contentFilter.selectedTypes && contentFilter.selectedTypes.length) {
      for (let type of contentFilter.selectedTypes) {
        if (type.name === listing.objectType) {
          typeMatch = true;
        }
      }
    }
    //Filter by selected calendar dates
    if (contentFilter.calendarDates.length || contentFilter.calendarDates.start) {
      let listingDate = new Date(listing.date);
      let filterStartDate = new Date(contentFilter.calendarDates.start);
      let filterEndDate = contentFilter.calendarDates.end ? new Date(contentFilter.calendarDates.end) : null;
      if (filterEndDate) filterEndDate.setHours(23, 59, 59); // end of day

      if ((filterStartDate && !filterEndDate) || filterStartDate.getTime() == filterEndDate.getTime()) {
        if (filterStartDate.getDate() === listingDate.getDate()
          && filterStartDate.getYear() === listingDate.getYear()
          && filterStartDate.getMonth() === listingDate.getMonth()) {
          calendarMatch = true;
        } else {
          return false;
        }
      }

      if ((listingDate >= filterStartDate)) {
        if ((listingDate <= filterEndDate)) {
          calendarMatch = true;
        }
      }
    }
    if (!contentFilter.showExpired && listing.expired) {
      return false;
    }

    return (stringMatch && groupMatch && typeMatch && calendarMatch);
  })

  const [isEdit, setIsEdit] = useState(false);
  const [showContentForm, setShowContentForm] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [dialogProps, setDialogProps] = useState({});
  const [showDialog, setShowDialog] = useState(false);

  const contentFormSubmit = (dataItem) => {
    const date = dataItem.date ? dataItem.date : new Date()
    dispatch(createContent({
      ...dataItem,
      date: date,
      siteId: user.site.id,
      user: user
    },
    token,
    formCloser(successfulSubmit)));
  }

  const successfulSubmit = (setter) => {
    setShowContentForm(false);
    setIsEdit(false);
    setInitialValues({});
  }

  const contentDelete = (id) => {
    dispatch(deleteContent(id, token, formCloser(setShowDialog)))
  }

  const contentUpdate = (id, dataItem, token) => {
    dispatch(updateContent(id, dataItem, token, formCloser(successfulSubmit)))
  }

  const deleteEntry = (dataItem) => {
    // prompt for confirmation
    setDialogProps({
      title: `Delete Content`,
      text: `Are you sure you want to delete ${dataItem.title}?`,
      onConfirm: () => contentDelete(dataItem.id),
      enableCancelBtn: true
    });

    setShowDialog(true);
  }

  return (
    <div style={{ width: '88vw' }}>
      <div
        style={{
          minHeight: 40,
          paddingBottom: 5,
          marginLeft: '15px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {!user.viewOnly && !user.notificationOnly ? <Button
          className="k-button k-primary"
          onClick={() => setShowContentForm(true)}
          iconClass="k-icon k-i-add"
        >
          Create Content
        </Button> : null}
        <Button
          className="k-button k-primary"
          style={{ height: 40, width: 40 }}
          onClick={() => {
            // ensure user drawer is selected, then show
            dispatch(setToContentDrawer)
            dispatch(toggleDrawer)
          }}
          iconClass="k-icon k-i-filter"
        />
      </div>
      <div
        style={{
          overflowY: "auto",
          maxHeight: "75vh",
          marginTop: 10
        }}>
        <StackLayout
          orientation={"vertical"}
          gap={15}
          style={{ margin: '0px 0px 15px 15px' }}
        >
          {filteredContent && filteredContent.map((listing) => {
            return <Content
              update={(data) => {
                //Re-create Groups as groups for InitialValues of KendoForm
                var dummy = structuredClone(data);
                dummy.groups = dummy.Groups;
                setInitialValues(dummy);
                setShowContentForm(true);
                setIsEdit(true);
              }}
            delete={deleteEntry} data={listing} />
          })}
        </StackLayout>
      </div>
      {showContentForm && (
        <ContentForm
          groups={groups}
          cancelEdit={() => {
            setShowContentForm(false);
            setIsEdit(false);
            setInitialValues({});
          }}
          values={initialValues}
          isEdit={isEdit}
          onSubmit={(dataItem) => {
            if (isEdit) {
              contentUpdate(dataItem.id, dataItem, token);
            } else {
              contentFormSubmit(dataItem);
            }
          }}
        />
      )}
      {showDialog &&
        <Dialog
          {...dialogProps}
          onClose={() => setShowDialog(false)}
        />}
    </div>
  )
}

export default DashboardPosts;